import { getCurrencySymbol } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { Currency } from '@core/pricing-types';
import type { PaymentInterval } from '@core/subscription-types';
import { MathPipe } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-plan-picker-product-price',
  templateUrl: './plan-picker-product-price.component.html',
  styleUrls: ['./plan-picker-product-price.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MathPipe, TranslatePipe],
})
export class PlanPickerProductPriceComponent {
  @Input() public interval: PaymentInterval;
  @Input() public currency: Currency;
  @Input() public costPerMonth: number;
  @Input() public costPerMonthWithoutDiscount: number;

  public currencySymbol: string;

  public ngOnChanges() {
    this.currencySymbol = getCurrencySymbol(this.currency, 'narrow');
  }
}
